import { EngineSignatureField } from "../models/EngineSignatureField";

export class PdfSignatureData {
  public svg!: string;
  public reason!: string;
  public location!: string;
  public signatureField!: EngineSignatureField;
  public signatureFields!: EngineSignatureField[];
  public lat!: string;
  public lon!: string;
  public image!: string;
  public embedTimestampInSvg: boolean = false;
}
